import React from "react";

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Content,
  ContentVariants,
  Label,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { Link } from "react-router-dom";


const AnnouncementCard = ({
  announcement
}) => {
  if (!announcement) {
    return null;
  }

  const {
    id,
    title = "",
    excerpt = "",
    publishedAt,
    image
  } = announcement;

  const publishDate = publishedAt
    ? new Date(publishedAt).toLocaleDateString(
        "pl-PL",
        {
          day: "numeric",
          month: "long",
          year: "numeric"
        }
      )
    : "";

  const detailsUrl = `/announcements/${id}`;

  return (
    <Card
      isGlass
      isFullHeight
    >
      {image?.src && (
        <Link
          to={detailsUrl}
          style={{
            display: "block",
            overflow: "hidden"
          }}
        >
          <img
            src={image.src}
            alt={image.alt || title}
            loading="lazy"
            style={{
              display: "block",
              width: "100%",
              height: "220px",
              objectFit: "cover"
            }}
          />
        </Link>
      )}

      <CardTitle>
        <Stack hasGutter>
            <StackItem isFilled />
          <StackItem>
            <Label
              variant="outline"
              color="blue"
            >
              Ogłoszenie
            </Label>
          </StackItem>

          {publishDate && (
            <StackItem>
              <Content
                component={ContentVariants.small}
              >
                {publishDate}
              </Content>
            </StackItem>
          )}
        </Stack>
      </CardTitle>

      <CardBody>
        <Stack hasGutter>
          <StackItem>
            <Content
              component={ContentVariants.h3}
            >
              {title}
            </Content>
          </StackItem>

          {excerpt && (
            <StackItem>
              <Content
                component={ContentVariants.p}
              >
                {excerpt}
              </Content>
            </StackItem>
          )}
        </Stack>
      </CardBody>

      <CardFooter>
        <Button
          component={Link}
          to={detailsUrl}
          variant="link"
          isInline
        >
          Zobacz ogłoszenie →
        </Button>
      </CardFooter>
    </Card>
  );
};


export default AnnouncementCard;